import React from 'react';

interface RoleLensChipProps {
  role: string;
}

/**
 * RoleLensChip — Shows current role as a chip/badge in the topbar.
 *
 * Displays the current workspace role with appropriate styling.
 */
export default function RoleLensChip({ role }: RoleLensChipProps) {
  // Map roles to display names
  const roleDisplayMap: Record<string, string> = {
    admin: 'Admin',
    analyst: 'Analyst',
    data_specialist: 'Data Specialist',
    accountant_internal: 'Internal Accountant',
    accountant_external: 'External Accountant',
    attorney: 'Attorney',
    client: 'Client',
  };

  const displayName = roleDisplayMap[role] || role;

  // Role chip is an identity label, not an active/done/brand signal — so it is
  // grayscale per the design spec (black+orange only; no blue/green/purple).
  const getRoleStyles = (_role: string): string =>
    'bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]';

  return (
    <div
      className={`
        inline-flex items-center px-2.5 py-1 rounded-full
        text-xs font-medium capitalize
        border
        ${getRoleStyles(role)}
      `}
    >
      {displayName}
    </div>
  );
}
